export const toolbarButtons = [
    { key: 'paragraph', title: 'Text', group: 'block', event: 'format-paragraph', activeBlockType: 'paragraph' },
    { key: 'heading', title: 'Title', group: 'block', event: 'format-heading', eventArg: 'h2', activeBlockType: 'h2' },
    { key: 'subheading', title: 'Subtitle', group: 'block', event: 'format-heading', eventArg: 'h3', activeBlockType: 'h3' },
    { key: 'caption', title: 'Caption', group: 'block', event: 'format-heading', eventArg: 'h4', activeBlockType: 'h4' },
    { key: 'quote', title: 'Quote', group: 'block', event: 'format-quote', activeBlockType: 'quote' },
    { key: 'bold', icon: 'bold', title: 'Bold', group: 'format', event: 'format-text', eventArg: 'bold' },
    { key: 'italic', icon: 'italic', title: 'Italic', group: 'format', event: 'format-text', eventArg: 'italic' },
    { key: 'underline', icon: 'underline', title: 'Underline', group: 'format', event: 'format-text', eventArg: 'underline' },
    { key: 'strikethrough', icon: 'strikethrough', title: 'Strikethrough', group: 'format', event: 'format-text', eventArg: 'strikethrough' },
    { key: 'link', icon: 'link', title: 'Link', group: 'format', event: 'link-toggle' },
    // Not in any preset: legacy section-header (project story only) — request explicitly via `toolbar-controls`.
    { key: 'section-header', icon: 'heading', title: 'Section header', group: 'format', event: 'section-header-toggle' },
    { key: 'clear-format', icon: 'eraser', title: 'Clear formatting', group: 'format', event: 'clear-format' },
    { key: 'ul', icon: 'list-ul', title: 'Bullet List', group: 'list', event: 'toggle-list', eventArg: 'ul' },
    { key: 'ol', icon: 'list-ol', title: 'Numbered List', group: 'list', event: 'toggle-list', eventArg: 'ol' },
    { key: 'media', icon: 'photo-film', title: 'Upload image or video', group: 'media', event: 'media-upload' },
    { key: 'attachment', icon: 'paperclip', title: 'Attach a file', group: 'media', event: 'attachment-insert' },
    { key: 'embed', icon: 'code', title: 'Embed', group: 'media', event: 'embed-toggle' },
    { key: 'projectCarousel', icon: 'table-cells', title: 'Insert project carousel', group: 'media', event: 'carousel-toggle' },
    { key: 'columns', icon: 'table-columns', title: 'Columns', group: 'media', event: 'columns-toggle' },
    // Not in any preset: requested explicitly via `toolbar-controls`, like section-header.
    { key: 'celebrate', icon: 'party-horn', title: 'Celebration', group: 'format', event: 'celebration-toggle' },
];

export const toolbarFormatValues = {
    bold: 'bold',
    italic: 'italic',
    link: 'link',
    clearFormat: 'clear-format',
    ul: 'ul',
    ol: 'ol',
    media: 'media',
    attachment: 'attachment',
    embed: 'embed',
    projectCarousel: 'projectCarousel',
    columns: 'columns',
    paragraph: 'paragraph',
    heading: 'heading',
    subheading: 'subheading',
    caption: 'caption',
    quote: 'quote',
    sectionHeader: 'section-header',
    underline: 'underline',
    strikethrough: 'strikethrough',
    celebrate: 'celebrate',
};

const inlineControls = [toolbarFormatValues.bold, toolbarFormatValues.italic, toolbarFormatValues.link, toolbarFormatValues.clearFormat];
const simpleControls = [
    toolbarFormatValues.paragraph, toolbarFormatValues.heading, toolbarFormatValues.subheading, toolbarFormatValues.caption, toolbarFormatValues.quote,
    toolbarFormatValues.bold, toolbarFormatValues.italic, toolbarFormatValues.underline, toolbarFormatValues.strikethrough, toolbarFormatValues.link, toolbarFormatValues.clearFormat, toolbarFormatValues.ul, toolbarFormatValues.ol,
];
const standardControls = [
    ...simpleControls,
    toolbarFormatValues.media, toolbarFormatValues.embed,
];

export const controlPresets = {
    inline: inlineControls,
    simple: simpleControls,
    standard: standardControls,
};

export const controlTypes = standardControls;

// Not offered or droppable inside a column: embeds/carousels out of scope, columns must not nest.
export const columnDisallowed = ['embed', 'projectCarousel', 'columns'];

const blockLevelKeys = new Set(
    toolbarButtons.filter(b => ['block', 'list', 'media'].includes(b.group)).map(b => b.key),
);

export function hasBlockLevelControls(controls) {
    return Array.isArray(controls) && controls.some(key => blockLevelKeys.has(key));
}

const headingTagByControl = { heading: 'h2', subheading: 'h3', caption: 'h4' };

// Which content the control set permits — pasted/migrated content outside this is downgraded (see useContentPolicy).
export function getContentPolicy(controls) {
    const set = new Set(Array.isArray(controls) ? controls : []);
    return {
        headingTags: Object.entries(headingTagByControl).filter(([key]) => set.has(key))
            .map(([, tag]) => tag),
        quote: set.has('quote'),
        list: set.has('ul') || set.has('ol'),
        link: set.has('link'),
        sectionHeader: set.has('section-header'),
        media: set.has('media'),
        embed: set.has('embed'),
        projectCarousel: set.has('projectCarousel'),
        attachment: set.has('attachment'),
        columns: set.has('columns'),
        celebration: set.has('celebrate'),
    };
}

export function getBlockOptions(controls) {
    return toolbarButtons.filter(b => b.group === 'block' && controls.includes(b.key));
}

export function getActiveBlockKey(blockOptions, blockType) {
    const match = blockOptions.find(b => b.activeBlockType === blockType);
    return match ? match.key : 'paragraph';
}
